/* eslint-disable no-undef */
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  selectAuthenticate,
  hideSmsModal,
  authenticateOtp,
  resetPasswordsWitSms
} from "../../../state/ducks/login";
import Countdown from "react-countdown";
import $ from "jquery";
import Modal from "react-modal";
import NumberFormat from "react-number-format";
import Inputmask from "inputmask";

import { alertActions } from "../../../state/ducks/alert/actions";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    border: "none",
    padding: "0",
    background: "none",
  },
};

Modal.setAppElement("#app");

class ExpirePassword extends Component {
  state = {
    smsCode: "",
    loginType: 1,
    platform: "web",
    token: "",
    newPassword: "",
    reNewPassword: "",
  };
  maskAndRegexInput() {

    var smsKodu = document.getElementById("sms_kodu");
    if (smsKodu != null) {

      Inputmask("(999) 999-99-99").mask(smsKodu);
    }

  }
  componentDidMount() {
    this.maskAndRegexInput()
    this.createCaptchaToken();
  }

  hideModal = () => {
    debugger;
    this.props.hideSmsModal();
  };

  timerEnd() {
    $("#sms_kodu").prop("disabled", true);
    $("#submit").css("pointer-events", "none");
    $("#tekrar_gonder").css("pointer-events", "all");
    $("#yeni_sifre").prop("disabled", true);
    $("#yeni_sifre_tekrar").prop("disabled", true);
  }

  timerStart() {
    var time = this.props.login?.countDate + 180000 < Date.now();
    $("#sms_kodu").prop("disabled", time);
    $("#submit").prop("disabled", time);
    $("#yeni_sifre").prop("disabled", time);
    $("#yeni_sifre_tekrar").prop("disabled", time);
    if (time) {
      $("#tekrar_gonder").css("pointer-events", "all");
    } else {
      $("#tekrar_gonder").css("pointer-events", "none");
    }
  }

  reSendSmsCode = (event) => {
    event.preventDefault();

    const { login } = this.props;
    debugger;

    const postData = {
      username: login.username,
      password: login.password,
      platform: 'web',
      token: this.state.token,
    };
    this.props.authenticateOtp(postData);
    this.setState({
      userName: "",
      password: "",
    });
    this.createCaptchaToken();
    $("#submit").css("pointer-events", "all");
  };

  loginShowPassword() {
    debugger;
    var loginPassword = document.getElementById("yeni_sifre");
    var iconLoginPassword = document.getElementById("iconLoginPassword");
    if (iconLoginPassword != null && loginPassword != null) {

      if (loginPassword.type == 'password') {
        loginPassword.type = 'text';

        iconLoginPassword.classList.remove("t-icon-eye-blocked");
        iconLoginPassword.classList.add("t-icon-eye");
      } else {
        loginPassword.type = 'password';
        iconLoginPassword.classList.remove("t-icon-eye");
        iconLoginPassword.classList.add("t-icon-eye-blocked");
      }
    }

  };
  loginShowRePassword() {
    var loginPassword = document.getElementById("yeni_sifre_tekrar");
    var iconLoginPassword = document.getElementById("iconLoginRePassword");
    if (iconLoginPassword != null && loginPassword != null) {

      if (loginPassword.type == 'password') {
        loginPassword.type = 'text';

        iconLoginPassword.classList.remove("t-icon-eye-blocked");
        iconLoginPassword.classList.add("t-icon-eye");
      } else {
        loginPassword.type = 'password';
        iconLoginPassword.classList.remove("t-icon-eye");
        iconLoginPassword.classList.add("t-icon-eye-blocked");
      }
    }

  };

  resetPasswordsWitSms = (event) => {
    event.preventDefault();

    var yeniSifre = document.getElementById("yeni_sifre");
    var yeniSifreTekrar = document.getElementById("yeni_sifre_tekrar");
    var smsKodu = document.getElementById("sms_kodu");

    // yeni şifre alanı
    if (this.state.newPassword === "") {
      // document.getElementById("li-mesaj").innerHTML =
      //   "Yeni şifre alanını boş bırakılamaz";
      // $("#hata").show();
      this.props.showError('Yeni şifre alanını boş bırakılamaz');
      return false;
    } else {
      if (this.state.newPassword !== this.state.reNewPassword) {

        // document.getElementById("li-mesaj").innerHTML =
        //   "Yeni şifreleriniz aynı olmalıdır.";
        // $("#hata").show();
        this.props.showError('Yeni şifreleriniz aynı olmalıdır.');
        return false;
      } else if (this.state.newPassword.length < 8) {

        // document.getElementById("li-mesaj").innerHTML =
        //   "Yeni şifreleriniz en az 8 karakter olmalıdır.";
        // $("#hata").show();

        this.props.showError('Yeni şifreleriniz en az 8 karakter olmalıdır.');
        return false;
      } else if (this.state.newPassword.search(/[a-z]/) < 0) {

        // document.getElementById("li-mesaj").innerHTML =
        //   "Yeni şifrelerinizde küçük harf bulunmalıdır";
        // $("#hata").show();
        this.props.showError('Yeni şifrelerinizde küçük harf bulunmalıdır');
        return false;
      } else if (this.state.newPassword.search(/[A-Z]/) < 0) {

        // document.getElementById("li-mesaj").innerHTML =
        //   "Yeni şifrelerinizde Büyük harf bulunmalıdır";
        // $("#hata").show();
        this.props.showError('Yeni şifrelerinizde Büyük harf bulunmalıdır');
        return false;
      } else if (this.state.newPassword.search(/[0-9]/) < 0) {

        // document.getElementById("li-mesaj").innerHTML =
        //   "Yeni şifreleriniz Rakam içermelidir.";
        // $("#hata").show();
        this.props.showError('Yeni şifreleriniz Rakam içermelidir.');
        return false;
      } else if (this.state.newPassword.search(/[!@#$%^&*(_),.?:|<>-]/) < 0) {
        this.props.showError('Yeni şifrelerinizde en az bir özel karakter (!@#$%^&*(_),.?:|<>-)  bulunmalıdır.');
        return false;
      } else {

      }

      //sms kodu alanı
      if (this.state.smsCode === "") {

        // document.getElementById("li-mesaj").innerHTML =
        //   "Sms Kodu alanını boş bırakılamaz";
        // $("#hata").show();
        this.props.showError('Sms Kodu alanını boş bırakılamaz');
        return false;
      } else {
        $("#hata").hide();
        var data = {
          kartId: this.props.login?.data?.cardId?.toString(),
          kartUyelikId: this.props.login?.data?.cardMemberId?.toString(),
          kimlikNo: this.props.login?.username,
          newPassword: this.state.newPassword,
          oldPassword: this.state.smsCode,
        };
        this.props.resetPasswordsWitSms(data);
        // this.setState({ smsCode: "", newPassword: "", reNewPassword: "" });
      }
    }
  };

  createCaptchaToken() {
    var that = this;
    grecaptcha.ready(function () {
      grecaptcha
        .execute("6LeiYdwUAAAAAFsmN76CLhs9VADdnPT4OnzKWCFT", {
          action: "/Home",
        })
        .then((token) => {
          that.setState({ token: token });
        });
    });
  }

  render() {

    const { login } = this.props;
    return (
      <Modal
        isOpen={login?.controlExpirePassword}
        onRequestClose={this.closeModal}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.70)"

          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            transform: "translate(-50%, -50%)",
            border: "none",
            padding: "0",
            background: "none",
            width: "100%"
          }
        }}
      >

        <div
          className="container-fluid"
          role="document"
          style={{ boxSizing: "unset" }}
        >

          <div className="row d-flex align-items-center justify-content-center vh-100">
            <div
              className="col-10 col-md-7 col-lg-6 col-xl-5 t-sifreAlaniPopup"

            >

              <div className="row no-gutters px-4">
                <div className="col-12 pr-4 d-flex justify-content-end " >
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => this.hideModal()}
                  >
                    <span aria-hidden="true" className="text-white">
                      &times;
                    </span>
                  </button>
                </div>

              </div>
              <div className="row no-gutters d-flex justify-content-center px-4">
                {/* LOGO */}
                <div className="col-12 d-flex justify-content-center pb-2">
                  <i className="t-icon-lock_clock t-loginSifreAlBaslikIcon" />
                </div>
                <div className="col-12 d-flex justify-content-center pb-3 t-loginSifreAlBaslik">
                  ŞİFRE YENİLEME
                </div>
                <div
                  className="col-12 col-lg-8 pb-2 text-center"
                  style={{ color: "#95C11F" }}
                >
                  <p>
                    {login?.response}
                  </p>
                </div>
                {/* TC Kimlik */}
                <div className="col-12 col-lg-10 col-xl-8 pb-2">
                  <span className="t-loginText pl-3">SMS Şifreniz</span>
                </div>
                <div className="col-12 col-lg-10 col-xl-8">
                  <div className="t-inputLogin">
                    <div>
                      <i className="t-icon-phonelink_lock" />
                    </div>
                    <NumberFormat
                      displayType={"input"}
                      maxLength="6"
                      minLength="6"
                      id="sms_kodu"
                      name="sms_kodu"
                      className="smsdecimalnumber"
                      placeholder="SMS Şifrenizi giriniz"
                      value={this.state.smsCode}
                      onChange={(e) => {
                        this.setState({ smsCode: e.target.value });
                      }}
                      required={true}
                      autoComplete="new-password"
                    />
                    <div />
                  </div>
                </div>

                {/* Yeni Şifre */}
                <div className="col-12 col-lg-10 col-xl-8 py-1">
                  <span className="t-loginText pl-3">Yeni Şifreniz</span>
                </div>
                <div className="col-12 col-lg-10 col-xl-8 pb-2">
                  <div className="t-inputLogin">
                    <div>
                      <i className="t-icon-lock1" />
                    </div>
                    <input
                      type="password"
                      autoComplete="new-password"
                      id="yeni_sifre"
                      name="yeni_sifre"
                      placeholder="Yeni Şifrenizi Giriniz"

                      value={this.state.newPassword}
                      onChange={(e) => {
                        this.setState({ newPassword: e.target.value });
                      }}
                    />
                    <div className="ml-auto">
                      <i
                        id="iconLoginPassword"
                        className="t-icon-eye-blocked t-cursorPointer"
                        onClick={this.loginShowPassword}
                      />
                    </div>

                  </div>
                </div>
                {/* Yeni Şifre Tekrar */}
                <div className="col-12 col-lg-10 col-xl-8 pb-1">
                  <span className="t-loginText pl-3">Yeni Şifreniz Tekrar</span>
                </div>
                <div className="col-12 col-lg-10 col-xl-8 pb-2">
                  <div className="t-inputLogin">
                    <div>
                      <i className="t-icon-lock1" />
                    </div>
                    <input
                      type="password"
                      id="yeni_sifre_tekrar"
                      autoComplete="new-password"
                      name="yeni_sifre_tekrar"
                      placeholder="Şifrenizi Giriniz"

                      value={this.state.reNewPassword}
                      onChange={(e) => {
                        this.setState({ reNewPassword: e.target.value });
                      }} />
                    <div className="ml-auto">
                      <i
                        id="iconLoginRePassword"
                        className="t-icon-eye-blocked t-cursorPointer"
                        onClick={this.loginShowRePassword}
                      />
                    </div>
                  </div>
                </div>

                <div
                  className="col-12 col-lg-8 py-4 text-center"
                  style={{ color: "#F39200", fontWeight: "bold" }}
                >
                  <i className="t-icon-clock" />
                  <Countdown
                    key={login?.countDate}
                    date={login?.countDate + 180000}
                    renderer={(props) => (
                      <strong id="count_down"> {props.total / 1000}</strong>
                    )}
                    onStart={() => this.timerStart()}
                    onComplete={() => this.timerEnd()}
                  ></Countdown>
                </div>
                {/* Geri Sayım JS si*/}
                {/* Geri Sayım JS si BİTTİ*/}
                {/* ara boşluk*/}
                <div className="col-12" />
                {/* GİRİŞ ve GERİ DON */}
                <div className="col-auto pt-4 px-1">
                  <a
                    href="#tekrar"
                    target="_parent"
                    id="tekrar_gonder"
                    name="tekrar_gonder"

                    onClick={this.reSendSmsCode}

                    className="t-loginGeridonButton"
                  >
                    <i className="t-icon-loop2 px-2" style={{ fontSize: "14pt" }} />
                    TEKRAR GÖNDER
                    <span className="pr-2" />
                  </a>
                </div>
                <div className="col-auto pt-4 px-1">
                  <button
                    className="t-loginGirisButton"
                    id="submit"
                    type="submit"

                    onClick={this.resetPasswordsWitSms}
                  // style={
                  //   login.success
                  //     ? { display: "none" }
                  //     : { display: "inline-block" }
                  // }
                  >
                    <span className="px-2" />
                    GİRİŞ
                    <i
                      className="t-icon-arrow-right2 pl-2"
                      style={{ fontSize: "14pt" }}
                    />
                  </button>

                </div>

                {/*  ARA Ayraç */}
                <div className="col-12 col-lg-10 col-xl-8">
                  <hr />
                </div>
                {/* Şifre Kuralları */}
                <div className="col-12 t-sifeOzellikText d-flex flex-column align-items-center">
                  <strong className="pb-2"> ŞİFRE DEĞİŞTİRME KURALLARI</strong>
                  <ol>
                    <li>
                      Şifreniz en az <strong>8</strong> karakter olmalıdır.
                    </li>
                    <li>
                      Şifrenizde en az <strong>bir tane Küçük harf</strong> olmalıdır.
                    </li>
                    <li>
                      Şifrenizde en az <strong>bir tane Büyük harf</strong> olmalıdır.
                    </li>
                    <li>
                      Şifrenizde en az <strong>bir tane rakam</strong> bulunmalıdır.
                    </li>
                    <li>
                      Şifrenizde en az <strong>bir özel karakter (!@#$%^&*(),.?:{ }|&lt;&gt;-_)</strong> bulunmalıdır.
                    </li>
                  </ol>

                </div>

              </div>
            </div>
          </div>
        </div>


      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    login: selectAuthenticate(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  authenticateOtp: (postData) => dispatch(authenticateOtp(postData)),
  resetPasswordsWitSms: (postData) => dispatch(resetPasswordsWitSms(postData)),
  hideSmsModal: () => dispatch(hideSmsModal()),
  showError: (message) => dispatch(alertActions.showError(message)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExpirePassword);
